import { computed } from "vue";
import type {ComputedRef} from "vue"

interface UsableCommonVars {
    curLanguage: ComputedRef<string>;
    cdn: ComputedRef<string>;
    wkLabels: ComputedRef<Record<string, string>>;
    options: ComputedRef<Record<string, string | []>>;
    baseURLIt: ComputedRef<string>;
    baseURL: ComputedRef<string>;
}

export function useCommonVars(): UsableCommonVars {
    const curLanguage = computed((): string  => document.documentElement.getAttribute("lang") || "it")
    const cdn = computed((): string => window["_cdn"])
    const wkLabels = computed((): Record<string, string> => window["_labels"])
    const options = computed((): Record<string, string | []>  => window["_options"])
    const baseURLIt = computed((): string  => window["_baseURLIt"])
    const baseURL = computed((): string => window["_baseURL"])

    return {
        curLanguage,
        cdn,
        wkLabels,
        options,
        baseURLIt,
        baseURL
    }

}
